import React from "react";
require('dotenv').config();
const alchemyKey = process.env.REACT_APP_ALCHEMY_KEY;
const { createAlchemyWeb3 } = require("@alch/alchemy-web3");
const web3 = createAlchemyWeb3(alchemyKey);
const contractABI = require("../contract-abi.json");
const contractAddress = "0x57788Db01a42600a0E216443c49e6a5086819dBc";

export const lockContract = new web3.eth.Contract(
    contractABI,
    contractAddress
  );
  

export const loadData = async (address) => { 
    if (navigator.onLine===false){
      return {"error":"An internet connection is needed"}
    }
    if (!window.ethereum || address === null || address === "") {
      return {
        "error":
          "Connect your Metamask wallet to execute the lock on the blockchain.",
      };
    }
    const data = await lockContract.methods.getData().call({
      from:address
    }); 
    return data;
}

export const lockFunds = async (address,amount,duration) => {
  let amountToWei=amount*(10**18)
  //initial checks
  if (navigator.onLine===false){
    return {"error":"An internet connection is needed"}
  }
  if (!window.ethereum || address === null || address === "") {
    return {
      "error":
        "Connect your Metamask wallet to execute the lock on the blockchain.",
    };
  }
  //set up transaction parameters
  const transactionParameters = {
    to: contractAddress, // Required except during contract publications.
    from: address, // must match user's active address.
    data: lockContract.methods.lockFunds(duration).encodeABI(),
    value:`0x${amountToWei.toString(16)}`
  };

  //sign the transaction
  try {
    const txHash = await window.ethereum.request({
      method: "eth_sendTransaction",
      params: [transactionParameters],
    });
    return {
      trx:`${txHash}`
    };
  } catch (error) {
    return {
      "error":error.message,
    };
  }
};


export const withdrawFunds = async (address) => {
    if (navigator.onLine===false){
      return {"error":"An internet connection is needed"}
    }
    if (!window.ethereum || address === null || address === "") {
      return {
        "error":
          "Connect your Metamask wallet to execute the withdrawal from the blockchain.",
      };
    }
    //set up transaction parameters
    const transactionParameters = {
      to: contractAddress, // Required except during contract publications.
      from: address, // must match user's active address.
      data: lockContract.methods.withdraw().encodeABI(),
    };
    
    //sign the transaction
    try {
      const txHash = await window.ethereum.request({
        method: "eth_sendTransaction",
        params: [transactionParameters],
      });
      return {
        trx:`${txHash}`
      };
    } catch (error) {
      return {
        "error":error.message,
      };
    }
};


export const connectWallet = async () => {
  if (window.ethereum) {
    try {
      const addressArray = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const obj = {
        status: "👆🏽 Write a message in the text-field above.",
        address: addressArray[0],
      };
      return obj;
    } catch (err) {
      return {
        address: "",
        error:err.message,
      };
    }
  } else {
    return {
      address: "",
      meta: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a target="_blank" rel="noopener noreferrer" href={`https://metamask.io/download`}>
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};
export const getCurrentWalletConnected = async () => {
  if (window.ethereum) {
    try {
      const addressArray = await window.ethereum.request({
        method: "eth_accounts",
      });
      if (addressArray.length > 0) {
        return {
          address: addressArray[0],
        };
      } else {
        return {
          address: "",
        };
      }
    } catch (err) {
      return {
        address: "",
      };
    }
  } else {
    return {
      address: "",
    };
  }
};

